<div class="container ref-income-container">
  <div class="header-nav">
    <button class="back" [routerLink]="['../referral-campaigns']">
      <mat-icon class="arrow-back">arrow_back_ios</mat-icon>
    </button>
    <h3>Лог доходов с рефералов</h3>
  </div>

  <div class="ref-income-section ref-income-section-daily">
    <h4 class="ref-income-section-title">
      <span
        matTooltip="Дневные подытоги по всем кампаниям рефовода (история профита). За дни без движения строки нет (оптимизация). Деньги — со знаком (минус = долг)."
        matTooltipPosition="above">
        История по дням
      </span>
    </h4>
    <div class="ref-income-table-container">
      <mat-table [dataSource]="dailyHistoryDataSource" class="table ref-income-table">

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Дата</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.date | date: 'dd.MM.yy' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="referralsTotalCount">
          <mat-header-cell *matHeaderCellDef>Рефералы</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.referralsTotalCount }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="referralsActivatedCount">
          <mat-header-cell *matHeaderCellDef>Активные</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.referralsActivatedCount }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="referralsLostCount">
          <mat-header-cell *matHeaderCellDef>Утраченные</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.referralsLostCount }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="rewardCoins">
          <mat-header-cell *matHeaderCellDef>Текущий баланс</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span
              matTooltip="{{ centsValue(element.rewardCoins) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(element.rewardCoins) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="forecastRewardCoins">
          <mat-header-cell *matHeaderCellDef>
            <span
              matTooltip="Сумма уже рассчитанных, но ещё не перенесённых периодов. Активные периоды без даты расчёта в прогноз не входят. Информационная величина: к выводу доступна только после месячного переноса."
              matTooltipPosition="above">
              Прогноз
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span
              matTooltip="{{ centsValue(element.forecastRewardCoins) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(element.forecastRewardCoins) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="dailyHistoryColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: dailyHistoryColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoadingDaily"></mat-progress-bar>
    </div>
  </div>

  <div class="ref-income-section ref-income-section-v2">
    <h4 class="ref-income-section-title">Транзакции</h4>
    <div class="ref-income-table-container">
      <mat-table [dataSource]="refTxV2DataSource" class="table ref-income-table"
                 matSort matSortActive="date" matSortDirection="desc"
                 [matSortDisableClear]="true" (matSortChange)="onTxSort($event)">

        <ng-container matColumnDef="referralUserId">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="ID приглашённого пользователя, по которому считается цикл прибыли."
                  matTooltipPosition="above">ID пользователя</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="ellipsis-text">
              <a [routerLink]="['../..', invitedUserId(row)]">{{ invitedUserId(row) }}</a>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Реферальный код кампании, к которой относится приглашённый."
                  matTooltipPosition="above">Реф. код</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{ row.referral?.referralCampaign?.code || '—' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="transactionId">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="ID первого финансового wallet-события, открывшего период."
                  matTooltipPosition="above">ID события</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ transactionId(row) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cycleStatus">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Активен — период ожидает расчёта; Рассчитан — результат зафиксирован, но ещё не перенесён; Перенесён — результат добавлен в доход месячной обработкой; Отменён — закрыт без начисления при смене привязки; Сброшен — закрыт администратором."
                  matTooltipPosition="above">Статус цикла</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span [matTooltip]="cycleStatusTooltip(row)" matTooltipPosition="above">
              {{ cycleStatus(row) }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="balanceStart">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="REAL-баланс непосредственно перед финансовым событием, открывшим период."
                  matTooltipPosition="above">Баланс (нач.)</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ centsValue(row.balanceStart) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(row.balanceStart) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="balanceEnd">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="REAL-баланс после последнего финансового события периода; у рассчитанного периода — баланс при срабатывании условия не больше 1 F."
                  matTooltipPosition="above">Баланс (кон.)</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ centsValue(row.balanceEnd) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(row.balanceEnd) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sumDeposits">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Сумма депозитов REAL за период. Авторитетное значение заполняется при расчёте периода."
                  matTooltipPosition="above">Сумма депозитов</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ centsValue(row.sumDeposits) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(row.sumDeposits) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sumWithdraw">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Сумма выводов REAL за период. Авторитетное значение заполняется при расчёте периода."
                  matTooltipPosition="above">Сумма выводов</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ centsValue(row.sumWithdraw) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(row.sumWithdraw) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="receivedCoins">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Знаковый результат периода: trunc((депозиты − выводы) × процент тира / 100). Рассчитывается при балансе не больше 1 F; в доход переносится после завершения UTC-месяца. Минус означает долг рефовода."
                  matTooltipPosition="above">Результат периода</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ row.rewardCoins | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ row.rewardCoins / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="rewardCoinsCalculated">
          <mat-header-cell *matHeaderCellDef>
            <span
              matTooltip="База формулы при доле 100%: депозиты − выводы. Процент тира здесь не применяется; знак сохраняется."
              matTooltipPosition="above">
              База профита (100%)
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span
              matTooltip="{{ centsValue(row.rewardCoinsCalculated) | fastCoinsToDollar }}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
              {{ centsValue(row.rewardCoinsCalculated) / 100 | number: '1.1-5' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="isHold">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Да — положительный результат перенесён в hold из-за payout-lock приглашённого. Отрицательный результат на hold не ставится."
                  matTooltipPosition="above">Hold</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.isHold ? 'Да' : 'Нет' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="calculatedAt">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Когда баланс реферала стал не больше 1 F и результат периода был рассчитан."
                  matTooltipPosition="above">Дата расчёта</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.calculatedAt ? (row.calculatedAt | date: 'dd.MM.yy HH:mm') : '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="creditedAt">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Когда ежедневный cron перенёс rewardCoins завершённого UTC-месяца в referrals/referral_campaigns либо административный reset закрыл цикл без переноса. В dev relaxed-режим ускорен."
                  matTooltipPosition="above">Перенос / сброс</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.creditedAt ? (row.creditedAt | date: 'dd.MM.yy HH:mm') : '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastWalletEventAt">
          <mat-header-cell *matHeaderCellDef>
            <span matTooltip="Время последнего финансового wallet-события периода; после расчёта — время события, закрывшего период."
                  matTooltipPosition="above">Посл. событие</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.lastWalletEventAt ? (row.lastWalletEventAt | date: 'dd.MM.yy HH:mm') : '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span matTooltip="Дата создания записи расчёта. Для исторических данных может совпадать с датой начала старого цикла."
                  matTooltipPosition="above">Дата записи</span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ row.createdAt | date: 'dd.MM.yy HH:mm' }} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="refTxV2Columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: refTxV2Columns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoadingV2"></mat-progress-bar>
    </div>
  </div>

  <mat-paginator
    #txPaginator
    [length]="totalRowsV2"
    [pageIndex]="currentPage"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChanged($event)"
    aria-label="Страница транзакций реферального дохода">
  </mat-paginator>
</div>
